module.exports = __webpack_public_path__ + "img/vendor_logo.af13955c.png";